import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Container,
  useMediaQuery,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";
import { benefitsList } from "./data";

const Benefits = () => {
  const isLargeScreen = useMediaQuery("(min-width:1600px)");

  return (
    <Box sx={{ flexGrow: 1, width: "100%", justifySelf: "center" }}>
      <Typography
        className="features-title"
        sx={{
          color: "#002367",
          fontFamily: "Light",
          fontSize: { xs: 24, sm: 32, md: 42 }, // Responsive font size
          fontWeight: "700",
          lineHeight: "35px",
          display: "flex",
          justifyContent: "center",
          marginTop: { xs: 6, sm: 6, md: 8, lg: 10, xl: 12 },
          marginBottom: { xs: 3, sm: 3, md: 4, lg: 6, xl: 6 },
        }}
      >
        Benefits of LLMInsight.ai
      </Typography>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        sx={{
          maxWidth: isLargeScreen ? "1600px" : "100%",
          margin: "0 auto",
        }}
      >
        {benefitsList.map((card, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={3}
            key={index}
            sx={{ display: "flex" }}
          >
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              style={{ width: "100%" }} // Ensures uniform width
            >
              <Card
                sx={{
                  flexGrow: 1, // Allows the card to fill the grid item space
                  border: "1px solid rgba(56, 55, 55, 0.2)",
                  borderRadius: 2,
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                  transition: "0.3s",
                  "&:hover": {
                    boxShadow: "2px 6px 25px rgba(0,0,0,0.2)",
                  },
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "center",
                  marginLeft: { xs: -2, sm: 0, md: 0, lg: 0, xl: 0 },
                }}
              >
                <CardContent sx={{ p: { xs: 2, sm: 3 }, flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: "Light",
                      fontSize: { xs: 14, sm: 16, md: 16, lg: 18, xl: 20 },
                      lineHeight: "35px",
                      mb: 1,
                      color: "#073D8D",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "Light",
                      fontSize: { xs: 8, sm: 9, md: 10, lg: 12, xl: 14 },
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      color: "#333",
                    }}
                  >
                    {card.description}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Benefits;
